import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import {Descriptions, Icon, Spin, Tabs} from 'antd';
import Accesses from "../views/Accesses";
import Actions from "../views/actions/Actions";
import {getClientById} from "../services/ClientsService";
import Users from "../views/users/Users";
import {isOwnerRole} from "../services/UsersService";

const TabPane = Tabs.TabPane;

class ManagementRoute extends Component {

    componentWillMount() {
        if (this.props.isAuthenticated) {
            this.setState({
                isLoading: true,
                isOwner: isOwnerRole(this.props.match.params.client)
            });
            getClientById(this.props.match.params.client).then(response => {
                this.setState({
                    client: response,
                    isLoading: false
                });
            });
        }
    }

    render() {
        if (this.state.isLoading) {
            return <div className="main-spin-container"><Spin size="large"/></div>
        }
        return (
            this.props.isAuthenticated ?
                <div>
                    <h2 className="float-right">
                        <Descriptions size="small" bordered>
                            <Descriptions.Item
                                label="Espacio">{this.state.client ? this.state.client.name : '...'}</Descriptions.Item>
                            <Descriptions.Item
                                label="Dirección">{this.state.client ? this.state.client.address : '...'}</Descriptions.Item>
                        </Descriptions>
                    </h2>
                    <div className="clear"></div>
                    <Tabs type="card" size="large">
                        <TabPane key={"actions"} tab={<span><Icon type="bars"/>Accesos</span>}>
                            <Accesses showAll={true} client={this.props.match.params.client}/>
                        </TabPane>
                        <TabPane key={"users"} tab={<span><Icon type="user"/>Usuarios</span>}>
                            <Users isAdmin={this.props.isAdmin} isOwner={this.state.isOwner} currentUser={this.props.userData} client={this.props.match.params.client}/>
                        </TabPane>
                        <TabPane disabled={true} key={"invites"} tab={<span><Icon type="mail"/>Invitaciones</span>}>
                            INVITES
                        </TabPane>
                        {
                            this.props.isAdmin ?
                                <TabPane key={"controls"} tab={<span><Icon type="setting"/>Acciones</span>}>
                                    <Actions client={this.props.match.params.client}/>
                                </TabPane> : null
                        }
                    </Tabs>
                </div> : <Redirect to={{pathname: '/', state: {from: this.props.location}}}/>
        );
    }
}

export default withRouter(ManagementRoute);


// WEBPACK FOOTER //
// ./src/app/routes/ManagementRoute.js